import { BOMFormat } from "./base";
/**
 * PCBWay BOM format
 * https://www.pcbway.com/assembly-file-requirements.html
 */
export class PCBWayFormat extends BOMFormat {
    static manufacturer = "PCBWay";
    static columns = {
        "Item #": (_item, rowNumber) => `${rowNumber}`, // not sure if this should be sequential number or a unique ID
        Designator: (item) => item.designators.join(","),
        Qty: "quantity",
        Manufacturer: "manufacturer",
        "Mfg Part #": "mpn",
        "Description / Value": (item) => item.specification.join(", "),
        "Package/Footprint": "package",
        Type: "mountType",
        "Your Instructions / Notes": "notes",
    };
}
//# sourceMappingURL=PCBWay.js.map